module.exports = __webpack_public_path__ + "static/media/copy_new.9d97dafa.svg";